import React, {useEffect, useState} from 'react';
import './LineReplyPreview.css';

export default function LineReplyPreview({reply, onJump}) {
  const [missing, setMissing] = useState(false);
  useEffect(()=>setMissing(false),[reply?.message_id,reply?.unavailable]);
  if (!reply) return null;
  const id = Number(reply.message_id);
  const available = !reply.unavailable && Number.isSafeInteger(id) && id > 0;
  const content = <><strong className="hc-reply-preview-sender">{reply.sender_display || '원본 메시지'}</strong><span className="hc-reply-preview-body">{reply.body_preview || '내용 없음'}</span></>;
  return <>
    {available ? <button type="button" className="hc-reply-preview" data-line-replies="line-replies-v155" title="원본 메시지로 이동"
      onClick={() => setMissing(onJump(id) === false)}>{content}</button>
      : <div className="hc-reply-preview" data-line-replies="line-replies-v155" role="note" style={{cursor:'default'}}>{content}</div>}
    {missing && <span role="status" style={{display:'block',padding:'5px 10px',fontSize:11,lineHeight:1.5}}>원문이 현재 목록에 없습니다. 이전 대화나 날짜 검색으로 확인해 주세요.</span>}
  </>;
}
